const C = window.KikTheme ?? {
  ready: !1,
  version: "0.1.0"
};
class x extends HTMLElement {
  connectedCallback() {
    this.initScrollAffordance(), this.links = [...this.querySelectorAll("[data-kik-nav-link]")], this.pairs = this.links.map((e) => {
      const t = e.getAttribute("href") ?? "", i = t.startsWith("#") && t.length > 1 ? document.getElementById(t.slice(1)) : null;
      return i ? { link: e, target: i } : null;
    }).filter(Boolean), this.addEventListener("click", this.onClick), this.pairs.length !== 0 && (window.addEventListener("scroll", this.onScroll, { passive: !0 }), this.onScroll());
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll), this.resizeObserver?.disconnect(), this.removeEventListener("click", this.onClick);
  }
  // Active tab = the last anchor scrolled past, i.e. the one closest to the bar without
  // being below it. Deliberately NOT IntersectionObserver: sections/kik-anchor.liquid
  // targets are zero-height markers, and an empty element only intersects while it is
  // physically inside the observed band — scroll past it and NO tab would be active.
  // Comparing rect tops handles markers and full-height sections identically, and needs
  // no assumption that nav block order matches the sections' order on the page.
  onScroll = () => {
    this.ticking || (this.ticking = !0, requestAnimationFrame(() => {
      this.ticking = !1;
      const e = this.offsetHeight + 1;
      let t = null, i = -1 / 0;
      for (const n of this.pairs) {
        const { top: c } = n.target.getBoundingClientRect();
        c <= e && c > i && (i = c, t = n);
      }
      this.setActive((t ?? this.pairs[0]).link);
    }));
  };
  // Mobile tabs overflow by design; fade the right edge only while there is more to reach,
  // otherwise the hint lies once you are at the end.
  initScrollAffordance() {
    const e = this.querySelector("[data-kik-nav-scroller]");
    if (!e) return;
    const t = () => {
      const i = e.scrollWidth - e.clientWidth - e.scrollLeft;
      e.dataset.kikScrollable = i > 1 ? "true" : "false";
    };
    e.addEventListener("scroll", t, { passive: !0 }), this.resizeObserver = new ResizeObserver(t), this.resizeObserver.observe(e), t();
  }
  onClick = (e) => {
    const t = e.target.closest?.("[data-kik-nav-link]"), i = t && this.pairs.find((n) => n.link === t);
    i && (e.preventDefault(), window.scrollTo({
      top: i.target.getBoundingClientRect().top + window.scrollY - this.offsetHeight,
      behavior: "smooth"
    }), this.setActive(t));
  };
  setActive(e) {
    for (const t of this.links)
      t === e ? t.setAttribute("aria-current", "true") : t.removeAttribute("aria-current");
  }
}
customElements.get("kik-section-nav") || customElements.define("kik-section-nav", x);
class A extends HTMLElement {
  connectedCallback() {
    this.timers = [], this.observers = [], this.mediaPlayers = [], this.initGalleryLabel(), this.initGalleryZoom(), this.initGalleryMedia(), this.initCountdown(), this.initCopy(), this.initQty(), this.initVariants(), this.initBundle(), this.initVideo(), this.initStickyAtc();
  }
  disconnectedCallback() {
    for (const e of this.timers) clearInterval(e);
    for (const e of this.observers) e.disconnect();
    for (const e of this.mediaPlayers) e.destroy?.();
    for (const e of this.querySelectorAll("[data-deferred-media] video")) e.pause();
  }
  // dev note: "Label only showing in first image". Flickity marks the active cell with
  // .is-selected but exposes no DOM event, so watch the class instead of reaching into it.
  initGalleryLabel() {
    const e = this.querySelector("[data-kik-gallery-label]"), t = this.querySelector("[data-main-media]");
    if (!e || !t) return;
    const i = () => {
      const c = t.querySelector("[data-main-slide]");
      e.hidden = !c?.classList.contains("is-selected");
    }, n = new MutationObserver(i);
    n.observe(t, { attributes: !0, attributeFilter: ["class"], subtree: !0 }), this.observers.push(n), requestAnimationFrame(i);
  }
  // The gallery's zoom button is the theme's own PhotoSwipe trigger. interactable.min.js
  // binds that click handler only inside T4SThemeSP.PhotoSwipe.gallery(), which
  // main-product.liquid's own script calls and nothing calls for this section — so the
  // button renders and silently does nothing. The handler is delegated on document, so one
  // call is enough; it is idempotent (jQuery namespaces the binding "click.pswp").
  // T4SThemeSP is a vendor global that may load after this element upgrades, hence the poll.
  initGalleryZoom() {
    if (!this.querySelector("[data-pswp-btn-triger]")) return;
    let e = 0;
    const t = setInterval(() => {
      const i = window.T4SThemeSP?.PhotoSwipe?.gallery;
      i && i(), (i || ++e > 40) && clearInterval(t);
    }, 100);
    this.timers.push(t);
  }
  // product-thumbnail intentionally defers non-image media inside a <template>. The legacy
  // main-product section gets that template cloned and upgraded by T4SThemeSP.Product, but
  // this standalone Kik section does not carry data-product-featured (and must not: that
  // controller would also take ownership of our custom variants and buy form). Reproduce
  // only the video part of its contract here: materialise the Shopify <video>, load the
  // standard Shopify video UI/Plyr, and bind the same carousel visibility events.
  initGalleryMedia() {
    const e = [...this.querySelectorAll(
      '[data-deferred-media][data-media-type="video"]'
    )].map((o) => {
      const a = o.querySelector(".t4s-pr"), k = a?.querySelector("template"), d = k?.content?.firstElementChild?.cloneNode(!0);
      return !a || !k || d?.tagName !== "VIDEO" ? null : (a.setAttribute("loaded", "true"), a.appendChild(d), k.remove(), o.classList.add("is--adding"), { slide: o, video: d });
    }).filter(Boolean);
    if (e.length === 0) return;
    const t = (o, a) => {
      const { slide: k } = o, h = k.dataset.enableVideoAutoplaying === "true";
      k.addEventListener("mediaHidden", () => a.pause?.()), k.addEventListener("mediaVisible", () => {
        !window.T4SThemeSP?.isTouch && h && a.play?.();
      });
    }, i = (o) => {
      o.video.controls = !0, o.video.classList?.add("kik-gallery-native-video"), o.slide.classList.add("is-media__initialized", "kik-native-video"), t(o, o.video);
    }, n = (o) => {
      if (o || typeof window.Shopify?.Video != "function") {
        e.forEach(i);
        return;
      }
      for (const a of e) {
        const { slide: k, video: h } = a;
        try {
          const d = new window.Shopify.Video(h, {
            loop: { active: k.dataset.enableVideoLooping === "true" },
            muted: k.dataset.enableVideoMuting === "true"
          });
          this.mediaPlayers.push(d), k.classList.add("is-media__initialized"), t(a, d);
        } catch {
          i(a);
        }
      }
    }, c = () => typeof window.Shopify?.loadFeatures != "function" ? !1 : (window.T4SThemeSP?.LibraryLoader?.load?.("plyrShopifyStyles"), window.Shopify.loadFeatures([
      {
        name: "video-ui",
        version: "2.0",
        onLoad: n
      }
    ]), !0);
    if (c()) return;
    let s = 0;
    const r = setInterval(() => {
      if (c()) {
        clearInterval(r);
        return;
      }
      ++s > 40 && (clearInterval(r), e.forEach(i));
    }, 100);
    this.timers.push(r);
  }
  initCountdown() {
    const e = this.querySelector("[data-kik-countdown]");
    if (!e) return;
    const t = Date.parse(e.dataset.endAt ?? "");
    if (Number.isNaN(t)) {
      e.hidden = !0;
      return;
    }
    const i = {
      day: e.querySelector("[data-kik-cd-day]"),
      hrs: e.querySelector("[data-kik-cd-hrs]"),
      min: e.querySelector("[data-kik-cd-min]"),
      sec: e.querySelector("[data-kik-cd-sec]")
    }, n = () => {
      const c = t - Date.now();
      if (c <= 0) {
        e.hidden = !0;
        return;
      }
      const s = Math.floor(c / 1e3), r = (o) => String(o).padStart(2, "0");
      i.day && (i.day.textContent = r(Math.floor(s / 86400))), i.hrs && (i.hrs.textContent = r(Math.floor(s % 86400 / 3600))), i.min && (i.min.textContent = r(Math.floor(s % 3600 / 60))), i.sec && (i.sec.textContent = r(s % 60));
    };
    n(), this.timers.push(setInterval(n, 1e3));
  }
  initCopy() {
    const e = this.querySelector("[data-kik-copy]");
    e && e.addEventListener("click", async () => {
      const t = e.querySelector("[data-kik-copy-label]"), i = t?.textContent;
      try {
        await navigator.clipboard.writeText(e.dataset.kikCopy ?? ""), t && (t.textContent = "COPIED");
      } catch {
        t && (t.textContent = "PRESS ⌘C");
      }
      t && setTimeout(() => {
        t.textContent = i;
      }, 2e3);
    });
  }
  initQty() {
    const e = this.querySelector("[data-kik-qty-input]");
    if (!e) return;
    const t = (i) => {
      const n = Math.max(1, (parseInt(e.value, 10) || 1) + i);
      e.value = String(n), e.dispatchEvent(new Event("change", { bubbles: !0 }));
    };
    this.querySelector("[data-kik-qty-minus]")?.addEventListener("click", () => t(-1)), this.querySelector("[data-kik-qty-plus]")?.addEventListener("click", () => t(1));
  }
  // Options come from the product's real option values, so the design's colour names are
  // never assumed. Matching is positional against variants.options.
  initVariants() {
    const e = this.querySelector("[data-kik-variant-picker]"), t = this.querySelector("[data-kik-variants]");
    if (!e || !t) return;
    let i;
    try {
      i = JSON.parse(t.textContent);
    } catch {
      return;
    }
    Array.isArray(i) && e.addEventListener("change", () => {
      const n = [...e.querySelectorAll("[data-kik-option]")].map(
        (s) => s.querySelector("[data-kik-option-input]:checked")?.value ?? null
      );
      for (const s of e.querySelectorAll("[data-kik-option]")) {
        const r = s.querySelector("[data-kik-option-input]:checked")?.value, o = s.querySelector("[data-kik-option-selected]");
        o && r && (o.textContent = r);
      }
      const c = i.find(
        (s) => n.every((r, o) => r === null || s.options[o] === r)
      );
      if (!c) {
        const s = this.querySelector("[data-kik-atc]");
        s && (s.disabled = !0, s.textContent = "Unavailable");
        return;
      }
      this.applyVariant(c);
    });
  }
  // Bundle selector (Figma 10564:241): row 1 is this product; rows 2+ are this product PLUS
  // extra accessory products. It deliberately does NOT touch the hero price. A native product
  // form can only post a single variant, and the theme's ajax cart reads that one `id`, so the
  // earlier "add extras, then replay the submit" hand-off silently lost the extras whenever the
  // theme intercepted the first submit. We now own the whole add for bundle rows: machine plus
  // every extra go up in ONE /cart/add.js call, then we send the shopper to the cart so the
  // full bundle is guaranteed to show. Machine-only rows fall through to the theme untouched.
  initBundle() {
    const e = this.querySelector("[data-kik-bundle]"), t = this.querySelector("[data-kik-buy] form"), i = t?.querySelector("[data-kik-atc]");
    if (!e || !t || !i) return;
    const n = (c) => {
      if (i.dataset.kikExtrasDone === "1") {
        delete i.dataset.kikExtrasDone;
        return;
      }
      const r = (e.querySelector("[data-kik-bundle-input]:checked")?.dataset.extraIds ?? "").split(",").map((a) => a.trim()).filter(Boolean);
      if (!r.length) return;
      c.preventDefault(), c.stopImmediatePropagation();
      const o = r.map((a) => ({ id: Number(a), quantity: 1 }));
      i.disabled = !0, fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: o })
      }).then((a) => {
        if (!a.ok) throw new Error("cart add failed");
        i.dataset.kikExtrasDone = "1", i.disabled = !1, i.click();
      }).catch((a) => {
        console.error("[kik-bundle] cart add failed", a), i.disabled = !1;
      });
    };
    i.addEventListener("click", n, !0), t.addEventListener("submit", n, !0);
  }
  // Shared by the variant picker and the bundle selector: point the buy form at `match`,
  // update the add-to-cart state, re-render the price block, and swap the gallery image.
  // Shopify money_format aware; shared by the hero price block and the sticky bar.
  formatMoney(e) {
    const t = window.Shopify?.money_format ?? "${{amount}}", i = (e / 100).toFixed(2);
    return t.replace(/\{\{\s*amount[^}]*\}\}/, i);
  }
  applyVariant(e) {
    const t = this.querySelector("[data-kik-variant-id]"), i = this.querySelector("[data-kik-atc]"), n = this.querySelector("[data-kik-price-now]"), c = this.querySelector("[data-kik-price-was]"), s = this.querySelector("[data-kik-price-save]"), r = (a) => this.formatMoney(a);
    t && (t.value = e.id), i && (i.disabled = !e.available, i.textContent = e.available ? i.dataset.kikAtcLabel ?? "ADD TO CART" : "Sold out"), n && (n.textContent = r(e.price));
    const o = e.compare_at_price > e.price;
    c && (c.hidden = !o, o && (c.textContent = r(e.compare_at_price))), s && (s.hidden = !o, o && (s.textContent = `SAVE ${r(e.compare_at_price - e.price)}`)), this.repaintBundle(e), this.selectVariantMedia(e), this.dispatchEvent(new CustomEvent("kik:variant", { detail: e }));
  }
  // Each bundle row's total is machine + extras. The machine is the LIVE variant, so when the
  // variant changes the row prices must follow — the same derivation the sticky bar uses
  // (data-extra-price/-compare hold the extras-only total per row). Mirrors the Liquid: the
  // row's compare line always exists and is toggled via `hidden`, so a variant change can move
  // a row on or off sale.
  repaintBundle(e) {
    const t = this.querySelector("[data-kik-bundle]");
    if (!t) return;
    const i = e.compare_at_price > e.price ? e.compare_at_price : e.price;
    for (const n of t.querySelectorAll("[data-kik-bundle-option]")) {
      const c = n.querySelector("[data-kik-bundle-input]"), s = n.querySelector("[data-kik-bundle-price]"), r = n.querySelector("[data-kik-bundle-compare]");
      if (!c || !s) continue;
      const o = Number(c.dataset.extraPrice) || 0, a = Number(c.dataset.extraCompare) || 0, k = e.price + o, h = i + a, d = h > k;
      s.textContent = this.formatMoney(k), r && (r.hidden = !d, d && (r.textContent = this.formatMoney(h)));
    }
  }
  // The gallery is the theme's own T4S/flickity slider (snippets/kik-product-gallery.liquid).
  // main-product.liquid's variant→media handler never runs for this standalone section, so
  // mirror the parts of it that matter (theme.min.js _updateMediaFilter / _switchMedia):
  // re-filter grouped media so the target slide is visible, then select the variant's
  // featured slide. selectCell takes the slide element directly (global.min.js queryCell),
  // so no fragile flickity-index math.
  selectVariantMedia(e) {
    const t = e.featured_media?.id;
    if (!t) return;
    const i = this.querySelector("[data-main-media]");
    if (!i || !i.classList.contains("flickityt4s-enabled")) return;
    const n = i.flickityt4s?.flkty ?? window.jQuery?.(i).data("flickityt4s");
    if (!n) return;
    const c = [...i.querySelectorAll("[data-main-slide]")];
    if (window.jQuery && c.some((o) => o.dataset.grname)) {
      const o = this.optionNames();
      let a = null, k = null;
      for (let h = 0; h < e.options.length; h++) {
        const d = (o[h] ?? "").toLowerCase(), y = e.options[h];
        if (!(!d || y == null) && c.some((p) => (p.dataset.grname || "").toLowerCase() === d)) {
          a = d, k = String(y).toLowerCase();
          break;
        }
      }
      if (a) {
        const h = c.filter(
          (d) => (d.dataset.grname || "").toLowerCase() === a && (d.dataset.grpvl || "").toLowerCase() === k
        );
        if (h.length) {
          for (const d of c) d.classList.add("is--media-hide");
          for (const d of h) d.classList.remove("is--media-hide");
          window.jQuery(i).trigger("update.flickityt4s");
        }
      }
    }
    const s = c.filter((o) => o.dataset.mediaId === String(t)), r = s.find((o) => o.offsetParent !== null) ?? s[0];
    r && n.selectCell(r, !1, !1);
  }
  // Option names in the product's option order (== variant.options order), read from the
  // picker's labels ("Colour:" → "Colour"). Used only to pair variant option values with the
  // gallery's grouped-media data-grname buckets.
  optionNames() {
    const e = this.querySelector("[data-kik-variant-picker]");
    return e ? [...e.querySelectorAll("[data-kik-option]")].map(
      (t) => (t.querySelector("p span")?.textContent ?? "").replace(/:\s*$/, "").trim()
    ) : [];
  }
  // Sticky add-to-cart (Figma 11025:3123 desktop / 11025:3140 mobile). A fixed bar that
  // reveals once the shopper reaches the bottom of the section, mirrors the hero's variant
  // and price, and proxies its click to the real buy-form button so the theme's ajax cart
  // and the bundle handler keep working unchanged. Variant state stays single-sourced: the
  // sticky select routes through applyVariant, which broadcasts "kik:variant" back so the
  // bar, the hero price, and the swatch picker never drift apart.
  initStickyAtc() {
    const e = this.querySelector("[data-kik-sticky]");
    if (!e) return;
    const t = this.querySelector("[data-kik-sticky-sentinel]"), i = e.querySelector("[data-kik-sticky-variant]"), n = e.querySelector("[data-kik-sticky-atc]"), c = e.querySelector("[data-kik-sticky-price-now]"), s = e.querySelector("[data-kik-sticky-price-was]"), r = e.querySelector("[data-kik-sticky-thumb]"), o = (u) => {
      if (!u) return u;
      try {
        const l = new URL(u, window.location.origin);
        return l.searchParams.set("width", "96"), l.href;
      } catch {
        return u;
      }
    }, a = this.querySelector("[data-kik-atc]"), k = this.querySelector("[data-kik-variant-id]"), h = this.querySelector("[data-kik-variant-picker]"), d = this.querySelector("[data-kik-bundle]");
    let y = [];
    try {
      y = JSON.parse(this.querySelector("[data-kik-variants]")?.textContent ?? "[]");
    } catch {
      y = [];
    }
    let p = y.find((u) => String(u.id) === String(k?.value)) ?? y[0] ?? null;
    const L = () => {
      const u = d?.querySelector("[data-kik-bundle-input]:checked");
      return {
        price: Number(u?.dataset.extraPrice) || 0,
        compare: Number(u?.dataset.extraCompare) || 0
      };
    }, S = () => {
      if (!p) return;
      const u = L(), l = p.price + u.price, f = (p.compare_at_price > p.price ? p.compare_at_price : p.price) + u.compare, b = f > l;
      c && (c.textContent = this.formatMoney(l)), s && (s.hidden = !b, b && (s.textContent = this.formatMoney(f)));
    };
    if (d?.addEventListener("change", S), i?.addEventListener("change", () => {
      const u = y.find((l) => String(l.id) === i.value);
      u && this.applyVariant(u);
    }), n?.addEventListener("click", () => {
      if (n.disabled) return;
      if (a && !a.disabled) {
        a.click();
        return;
      }
      const u = k?.value || i?.value;
      u && fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: Number(u), quantity: 1 })
      }).then((l) => {
        l.ok && (window.location.href = "/cart");
      }).catch((l) => console.error("[kik-sticky] cart add failed", l));
    }), this.addEventListener("kik:variant", (u) => {
      const l = u.detail;
      l && (p = l, i && String(i.value) !== String(l.id) && (i.value = String(l.id)), r && l.featured_image?.src && (r.src = o(l.featured_image.src), r.alt = l.featured_image.alt || l.name || r.alt), S(), n && (n.disabled = !l.available), h?.querySelectorAll("[data-kik-option]").forEach((f, b) => {
        const w = l.options[b];
        if (w == null) return;
        const q = f.querySelector(`[data-kik-option-input][value="${CSS.escape(w)}"]`);
        q && (q.checked = !0);
        const E = f.querySelector("[data-kik-option-selected]");
        E && (E.textContent = w);
      }));
    }), t && "IntersectionObserver" in window) {
      const u = (f) => {
        e.classList.toggle("translate-y-full", !f), e.classList.toggle("pointer-events-none", !f), e.setAttribute("aria-hidden", f ? "false" : "true");
      }, l = new IntersectionObserver((f) => {
        for (const b of f)
          u(b.isIntersecting || b.boundingClientRect.top < 0);
      });
      l.observe(t), this.observers.push(l);
    }
    S();
  }
  // dev note: "Video: open pop up" + UGC videos. Media is torn down on every open and
  // close so nothing keeps playing behind the backdrop.
  initVideo() {
    const e = this.querySelector("[data-kik-video-modal]"), t = this.querySelector("[data-kik-video-slot]"), i = () => {
      if (t) {
        for (const s of t.querySelectorAll("video"))
          s.pause(), s.removeAttribute("src"), s.load();
        t.replaceChildren();
      }
    }, n = (s) => {
      if (!(!e || !t)) {
        i(), t.replaceChildren(s);
        for (const r of t.querySelectorAll("video, iframe"))
          r.style.width = "100%", r.style.height = "100%", r.tagName === "VIDEO" && (r.style.objectFit = "contain"), r.tagName === "IFRAME" && (r.style.border = "0");
        typeof e.showModal == "function" ? e.showModal() : e.setAttribute("open", "");
      }
    };
    for (const s of this.querySelectorAll("[data-kik-video-open]"))
      s.addEventListener("click", () => {
        const r = this.querySelector("[data-kik-video-tpl]");
        r && n(r.content.cloneNode(!0));
      });
    for (const s of this.querySelectorAll("[data-kik-ugc-open]"))
      s.addEventListener("click", () => {
        const { youtube: r, video: o } = s.dataset;
        if (r) {
          const a = document.createElement("iframe");
          a.src = this.toEmbedUrl(r), a.allow = "autoplay; encrypted-media; picture-in-picture", a.allowFullscreen = !0, a.setAttribute("frameborder", "0"), n(a);
        } else if (o) {
          const a = document.createElement("video");
          a.src = o, a.controls = !0, a.autoplay = !0, a.playsInline = !0, n(a);
        }
      });
    const c = () => {
      i(), typeof e?.close == "function" ? e.close() : e?.removeAttribute("open");
    };
    this.querySelector("[data-kik-video-close]")?.addEventListener("click", c), e?.addEventListener("close", i), e?.addEventListener("click", (s) => {
      s.target === e && c();
    });
  }
  toEmbedUrl(e) {
    const t = e.match(/[?&]v=([\w-]{11})/)?.[1] ?? e.match(/youtu\.be\/([\w-]{11})/)?.[1] ?? e.match(/embed\/([\w-]{11})/)?.[1];
    return t ? `https://www.youtube.com/embed/${t}?autoplay=1` : e;
  }
}
customElements.get("kik-product-main") || customElements.define("kik-product-main", A);
class v extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector("[data-kik-scroller]"), this.thumb = this.querySelector("[data-kik-thumb]"), !(!this.scroller || !this.thumb) && (this.update = this.update.bind(this), this.scroller.addEventListener("scroll", this.update, { passive: !0 }), this.observer = new ResizeObserver(this.update), this.observer.observe(this.scroller), this.update());
  }
  disconnectedCallback() {
    this.scroller?.removeEventListener("scroll", this.update), this.observer?.disconnect();
  }
  update() {
    const t = this.thumb.parentElement.clientWidth, { scrollWidth: i, clientWidth: n, scrollLeft: c } = this.scroller, s = i > 0 ? n / i : 1;
    if (s >= 1 || t === 0) {
      this.thumb.style.width = "0px";
      return;
    }
    const r = Math.max(t * s, M), o = i - n, a = o > 0 ? c / o : 0;
    this.thumb.style.width = `${r}px`, this.thumb.style.transform = `translateX(${a * (t - r)}px)`;
  }
}
const M = 24;
class I extends v {
}
class _ extends v {
}
class N extends v {
}
class T extends v {
}
customElements.get("kik-core-benefits") || customElements.define("kik-core-benefits", I);
customElements.get("kik-how-it-works") || customElements.define("kik-how-it-works", _);
customElements.get("kik-use-case") || customElements.define("kik-use-case", N);
customElements.get("kik-comparison") || customElements.define("kik-comparison", T);
class P extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')], this.panels = this.tabs.map((e) => this.querySelector(`#${CSS.escape(e.getAttribute("aria-controls"))}`)), this.media = [...this.querySelectorAll("[data-kik-tab-media]")], !(this.tabs.length < 2) && (this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this), this.addEventListener("click", this.onClick), this.addEventListener("keydown", this.onKeydown));
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.onClick), this.removeEventListener("keydown", this.onKeydown);
  }
  onClick(e) {
    const t = e.target.closest('[role="tab"]');
    t && this.select(this.tabs.indexOf(t));
  }
  onKeydown(e) {
    const t = this.tabs.indexOf(e.target.closest('[role="tab"]'));
    if (t === -1) return;
    const i = this.tabs.length - 1, n = {
      ArrowRight: t === i ? 0 : t + 1,
      ArrowLeft: t === 0 ? i : t - 1,
      Home: 0,
      End: i
    }[e.key];
    n !== void 0 && (e.preventDefault(), this.select(n), this.tabs[n].focus());
  }
  select(e) {
    this.tabs.forEach((t, i) => {
      const n = i === e;
      t.setAttribute("aria-selected", String(n)), t.tabIndex = n ? 0 : -1, this.panels[i]?.toggleAttribute("hidden", !n), this.media[i]?.toggleAttribute("hidden", !n);
    });
  }
}
customElements.get("kik-spec") || customElements.define("kik-spec", P);
const g = () => {
  C.ready = !0, document.documentElement.dataset.kikTheme = "ready";
};
window.KikTheme = C;
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", g, { once: !0 }) : g();
document.addEventListener("shopify:section:load", g);
